export const SAUDI_MOBILE_NUMBER = '^(05|9665)[0-9]{8}$';
export const VALID_YEAR = '^(19|20)[0-9]{2}$';
export const MOBILE_START_WITH_5 = '^(5)[0-9]{8}$';
export const MOBILE_START_WITH_05 = '^(05)[0-9]{8}$';
